<div class="switch__container">
    <input
        [tabindex]="0"
        [id]="id()"
        class="switch switch--shadow"
        type="checkbox"
        [formControl]="formControl"
    />

    <label [for]="id()"></label>
</div>
